<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="leave_type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.leave_type"
        :items="optionCodeLeaveTypeItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeLeaveTypeWorking"
        name="leave_type"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.leave_type"
        :readonly="!create"
      >
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="start_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <date-input
        v-model="item.start_date"
        name="start_date"
        v-bind="schema.fields.start_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        :first-day-of-week="1"
        :min-date="begin_start_date"
        :max-date="max_start_date"
        hide-time
        :readonly="!create"
        @input="dateChanged()"
      ></date-input>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="end_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <date-input
        v-model="item.end_date"
        name="end_date"
        v-bind="schema.fields.end_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        :first-day-of-week="1"
        :min-date="begin_end_date"
        hide-time
        :readonly="!create"
        @input="dateChanged()"
      ></date-input>
    </o-widget-wrapper>

    <o-form-group id="warning">
      <b-alert variant="warning" :show="notificationShown"
        >BLOCKED: Your leave will only be accepted in special circumstances.
        (From: <strong>{{ blockedStartDate }}</strong> To:
        <strong>{{ blockedEndDate }}</strong
        >)</b-alert
      >
    </o-form-group>

    <o-form-group id="long-warning">
      <b-alert variant="danger" :show="longWarning">
        WARNING: Your leave is over {{ numberOfMonths }} months long.
      </b-alert>
    </o-form-group>

    <check-leave-limits
      :employee-id="employeeId"
      :start-date="item.start_date"
      :end-date="item.end_date"
    />

    <o-form-group :label="schema.fields.part_of_day.label" id="part_of_day">
      <b-button-group>
        <b-button
          :variant="part_of_day_variants.full"
          @click="setFull()"
          :disabled="!create"
          >Full</b-button
        >
        <b-button
          v-if="!is_full_day"
          :variant="part_of_day_variants.am"
          @click="setAM()"
          :disabled="!create"
          >AM</b-button
        >
        <b-button
          v-if="!is_full_day"
          :variant="part_of_day_variants.pm"
          @click="setPM()"
          :disabled="!create"
          >PM</b-button
        >
        <b-button
          v-if="!is_full_day"
          :variant="part_of_day_variants.partial"
          @click="setPartial()"
          :disabled="!create"
          >Partial</b-button
        >
      </b-button-group>
    </o-form-group>

    <o-form-group id="dates">
      <b-container class="bv-example-row">
        <o-widget-wrapper
          :schema="schema"
          name="start_time"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
          v-if="showTimesOnEdit"
        >
          <label>{{ schema.fields.start_time.label }}</label>
          <b-form-timepicker
            v-model="item.start_time"
            @hidden="checkTime"
            locale="en"
            :readonly="!create"
          ></b-form-timepicker>
        </o-widget-wrapper>
        <o-widget-wrapper
          :schema="schema"
          name="end_time"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
          v-if="showTimesOnEdit"
        >
          <label>{{ schema.fields.end_time.label }}</label>
          <b-form-timepicker
            v-model="item.end_time"
            @hidden="checkTime"
            locale="en"
            :readonly="!create"
          ></b-form-timepicker>
        </o-widget-wrapper>
      </b-container>
    </o-form-group>

    <!--o-widget-wrapper
      :schema="schema"
      name="start_time"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.start_time"
        :form-state="formState"
        name="start_time"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.start_time"
      ></o-text-field>
    </o-widget-wrapper-->

    <!--o-widget-wrapper
      :schema="schema"
      name="end_time"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.end_time"
        :form-state="formState"
        name="end_time"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.end_time"
      ></o-text-field>
    </o-widget-wrapper-->
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import UseCodeModulesMixin from "@/vue-ocom/mixins/UseCodeModulesMixin.js";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import DateInput from "../../components/DateInput.vue";

import moment from "moment";
import CheckLeaveLimits from "./CheckLeaveLimits.vue";

import { default as CodeLeaveTypeForm } from "../../code_leave_type/components/ItemForm";
export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("LeaveRequestType"),
    UseCodeModulesMixin(["CodeLeaveType", "LeaveRequest"]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,
    DateInput,

    OCheckbox,
    OSelect,
    OTextField,

    CodeLeaveTypeForm,
    CheckLeaveLimits,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
    notificationShown: { type: Boolean, default: false },
    blockedStartDate: { type: String, default: "" },
    blockedEndDate: { type: String, default: "" },
    index: { type: Number, default: 0 },
    items: { type: Array, default: () => [] },
    employeeId: {},
  },
  data: () => ({
    maxMonths: 13,
    schemaModel: cleanUpModel(schema.LeaveRequestType, {}),
  }),
  methods: {
    setFull() {
      // Set item.part_of_day
      this.item.part_of_day = 1;
      // Clear item.start_time and item.end_time
      this.item.start_time = "";
      this.item.end_time = "";
    },
    setAM() {
      // Set item.part_of_day
      this.item.part_of_day = 2;
      // Set default time
      this.item.start_time = "06:00:00";
      this.item.end_time = "12:00:00";
    },
    setPM() {
      // Set item.part_of_day
      this.item.part_of_day = 3;
      // Set default time
      this.item.start_time = "12:00:00";
      this.item.end_time = "20:00:00";
    },
    setPartial() {
      // Set item.part_of_day
      this.item.part_of_day = 4;
      // Set 10am to 2pm
      this.item.start_time = "10:00:00";
      this.item.end_time = "14:00:00";
    },
    dateChanged() {
      if (
        this.item["start_date"] !== undefined &&
        this.item["end_date"] !== undefined
      ) {
        this.checkBlockOutDates();
        this.checkIfFullDay();

        var isStartDateLessThanThreeDays = this.isStartDateLessThanThreeDays;
        this.$emit("start_date_less_than_3_days", isStartDateLessThanThreeDays);
      }
    },
    checkBlockOutDates() {
      var dates = {
        start_date: this.item.start_date,
        end_date: this.item.end_date,
      };
      this.$emit("changedDates", dates);
    },
    checkIfFullDay() {
      // If full day (start_date and end_date are more than 1 day)
      if (this.is_full_day) {
        // Highlight full button
        this.full_button_variant = "dark";
        // Set part_of_day
        this.item.part_of_day = 1;
      }
    },
    checkTime(time) {
      var temp = null;

      if (
        moment(this.item.start_time, "HH:mm:ss").isAfter(
          moment(this.item.end_time, "HH:mm:ss")
        )
      ) {
        temp = this.item.start_time;
        this.item.start_time = this.item.end_time;
        this.item.end_time = temp;
      }
    },
  },
  computed: {
    create() {
      return !this.item.id; // are we creating a new Entry?
    },
    is_full_day() {
      var days = moment(this.item.end_date).diff(this.item.start_date, "days");
      if (Number.isNaN(days)) {
        days = 1; // No dates yet assume atleast 1 day
      }

      return days >= 1;
    },
    part_of_day_variants() {
      var result = {
        full: "outline-dark",
        am: "outline-dark",
        pm: "outline-dark",
        partial: "outline-dark",
      };
      if (this.item.part_of_day === 1) {
        result.full = "dark";
      }
      if (this.item.part_of_day === 2) {
        result.am = "dark";
      }
      if (this.item.part_of_day === 3) {
        result.pm = "dark";
      }
      if (this.item.part_of_day === 4) {
        result.partial = "dark";
      }

      return result;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    showTimesOnEdit() {
      return this.item.part_of_day != 1;
    },
    begin_start_date() {
      if (this.item.id !== undefined) {
        return this.item.start_date;
      }
      if (this.index === 0) {
        // min-date of start_date should be current date
        return moment(new Date()).format("YYYY-MM-DD").toString();
      }

      var previousEndDate = this.items[this.index - 1]["end_date"];
      if (previousEndDate !== "") {
        var startDate = moment(previousEndDate, "YYYY-MM-DD")
          .add(1, "days")
          .format("YYYY-MM-DD")
          .toString();

        if (this.item.end_date === null) return startDate;
        else if (this.item.end_date !== null) return this.item["start_date"];
      } else return null;
    },
    max_start_date() {
      if (this.index === 0) {
        // max-date of start_date should be null
        return null;
      } else {
        var previousEndDate = this.items[this.index - 1]["end_date"];
        return moment(previousEndDate, "YYYY-MM-DD")
          .add(1, "days")
          .format("YYYY-MM-DD")
          .toString();
      }
    },
    begin_end_date() {
      if (
        this.index === 0 &&
        (this.item.start_date === undefined || this.item.start_date === null)
      ) {
        // min-date of end_date should be current date
        return moment(new Date()).format("YYYY-MM-DD").toString();
      }
      if (
        this.index === 0 &&
        (this.item.start_date !== undefined || this.item.start_date === null)
      ) {
        return this.item.start_date;
      }

      var previousEndDate = this.items[this.index - 1]["end_date"];
      if (previousEndDate !== "") {
        var startDate = moment(previousEndDate, "YYYY-MM-DD")
          .add(1, "days")
          .format("YYYY-MM-DD")
          .toString();

        if (this.item.end_date === null) return startDate;
        else if (this.item.end_date !== null) return this.item["start_date"];
      } else return null;
    },
    isStartDateLessThanThreeDays() {
      if (this.item && this.item.start_date) {
        const startDate = new Date(this.item.start_date);
        const currentDate = new Date();
        const threeDaysFromNow = new Date(currentDate);

        // Add 5 days to the current date
        threeDaysFromNow.setDate(currentDate.getDate() + 5);

        // Check if start_date is less than three days from now
        return startDate < threeDaysFromNow;
      }

      return false;
    },
    numberOfMonths() {
      const startDate = moment(this.item.start_date);
      const endDate = moment(this.item.end_date);
      const numberOfMonths = endDate.diff(startDate, "months");
      if (Number.isNaN(numberOfMonths)) {
        return 0;
      }
      return numberOfMonths;
    },
    longWarning() {
      const isLongLeave = this.numberOfMonths >= this.maxMonths;
      return isLongLeave;
    },
  },
  watch: {},
  created() {},
  mounted() {
    if (this.item["part_of_day"] === 1) this.full_button_variant = "dark";
    if (this.item["part_of_day"] === 2) this.am_button_variant = "dark";
    if (this.item["part_of_day"] === 3) this.pm_button_variant = "dark";
    if (this.item["part_of_day"] === 4) this.partial_button_variant = "dark";
  },
};
</script>
